import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const DEFAULT = { custom: false, brandName: 'Teve', logoUrl: null, poweredBy: 'Siman Tech', signupAllowed: true, loaded: false };

const BrandingContext = createContext(DEFAULT);
export const useBranding = () => useContext(BrandingContext);

const CACHE_KEY = 'teve_branding';

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(() => {
    try {
      const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached) return { ...DEFAULT, ...cached, loaded: true };
    } catch (_) {}
    return DEFAULT;
  });

  useEffect(() => {
    let alive = true;
    axios.get(`${API_URL}/branding`)
      .then(({ data }) => {
        if (!alive) return;
        const next = {
          custom: !!data.custom,
          brandName: data.brand_name || 'Teve',
          logoUrl: data.logo_url || null,
          poweredBy: data.powered_by || 'Siman Tech',
          domain: data.domain || null,
          // account creation is only allowed on the platform's own hosts
          signupAllowed: data.signup_allowed !== false,
          loaded: true,
        };
        setBranding(next);
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(next)); } catch (_) {}
      })
      .catch(() => setBranding((b) => ({ ...b, loaded: true })));
    return () => { alive = false; };
  }, []);

  // Reflect brand in the browser chrome on a customer domain.
  useEffect(() => {
    if (!branding.loaded) return;
    if (branding.custom) {
      document.title = branding.brandName;
      if (branding.logoUrl) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
        link.href = branding.logoUrl;
      }
    }
  }, [branding]);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
};

export default BrandingContext;
